// src/services/oneSignalService.js
import { isLocalToRemote } from "../utils/authHelper";

/**
 * OneSignal Service
 * Handles user identity linking and subscription status.
 */

const isEnabled = () => {
  // Only enable OneSignal for TWA (Mobile App), localhost, or testing.
  // Standard web browser on bookizap.com is excluded (isLocalToRemote === false).
  return isLocalToRemote();
};

export const oneSignalLogin = async (userId) => {
  if (!isEnabled()) {
    
    return;
  }
  
  try {
    if (!userId) return;

    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async (OneSignal) => {
      try {
        if (!OneSignal) {
          
          return;
        }

        
        
        // Link the backend userId to OneSignal's external_id
        if (userId) {
          await OneSignal.login(userId.toString());
          
          // Optional: Tag the user for segmentation if needed
          await OneSignal.User.addTag("user_role", "client");
          
        }
      } catch (innerError) {
        
      }
    });
  } catch (error) {
    
  }
};

export const oneSignalLogout = async () => {
  if (!isEnabled()) return;
  
  try {
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async (OneSignal) => {
      await OneSignal.logout();
      
    });
  } catch (error) {
    
  }
};

export const requestNotificationPermission = () => {
  if (!isEnabled()) return;
  
  window.OneSignalDeferred = window.OneSignalDeferred || [];
  window.OneSignalDeferred.push(async (OneSignal) => {
    await OneSignal.Notifications.requestPermission();
  });
};

const oneSignalService = {
  login: oneSignalLogin,
  logout: oneSignalLogout,
  requestPermission: requestNotificationPermission,
};

export default oneSignalService;
